// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz@0,6..96;1,6..96&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* BASE COLOR
------------------------------------------------------------*/
/* DISPLAY SETTING
------------------------------------------------------------*/
/* OTHER SETTING
------------------------------------------------------------*/
[data-v-7653fc8a]:root {
  font-size: calc(14.5px + 1.5 * (100vw - 1440px) / 480);
  --cx: 0;
  --cy: 0;
  --vw: 100vw;
  --vh: 100vh;
  --screen: 0px;
  --size: 32px;
}
@media screen and (min-width: 1920px) {
[data-v-7653fc8a]:root {
    font-size: 16px;
}
}
@media screen and (max-width: 1023px) {
[data-v-7653fc8a]:root {
    font-size: 14px;
    --size: 16px;
}
}
@media screen and (max-width: 769px) {
[data-v-7653fc8a]:root {
    font-size: 13.5px;
    --size: 10px;
}
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 100;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 200;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 300;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 400;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 500;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Bold");
  font-weight: bold;
}
.nav-enter-active[data-v-7653fc8a],
.nav-leave-active[data-v-7653fc8a] {
  transition: opacity 0.5s cubic-bezier(0.65, 0, 0.35, 1);
}
.nav-enter-from[data-v-7653fc8a],
.nav-leave-to[data-v-7653fc8a] {
  opacity: 0;
}
header[data-v-7653fc8a] {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  padding: 0;
  display: grid;
  grid-template-columns: auto auto;
  z-index: 1000;
}
@media screen and (max-width: 769px) {
header[data-v-7653fc8a] {
    position: absolute;
}
}
header.pc[data-v-7653fc8a]:before {
  height: 25dvh;
  opacity: 0.8;
}
header[data-v-7653fc8a]:before {
  content: "";
  width: 100%;
  height: 15dvh;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0), black);
  opacity: 0.4;
  pointer-events: none;
  z-index: -1;
}
header .logo[data-v-7653fc8a] {
  margin: 1.2rem 0 0 calc(var(--size) + 2vw);
  width: 14.4rem;
  justify-self: flex-start;
}
@media screen and (max-width: 769px) {
header .logo[data-v-7653fc8a] {
    width: 10rem;
}
}
header .logo img[data-v-7653fc8a] {
  width: 100%;
}
header .gnavi[data-v-7653fc8a] {
  position: absolute;
  top: 1.6rem;
  left: 50%;
  transform: translate(-50%, 0);
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 1023px) {
header .gnavi[data-v-7653fc8a] {
    top: 0;
    min-height: 100vmax;
}
}
header .gnavi li[data-v-7653fc8a] {
  margin: 0 0 0 2.4rem;
}
@media screen and (max-width: 1023px) {
header .gnavi li[data-v-7653fc8a] {
    margin: 0;
}
}
header .gnavi li[data-v-7653fc8a]:first-child {
  margin: 0;
}
header .gnavi li a[data-v-7653fc8a] {
  font-size: 1.08rem;
  color: #fafbf6;
  position: relative;
  transition: color 200ms cubic-bezier(0.65, 0, 0.35, 1);
}
header .gnavi li a[data-v-7653fc8a]:before {
  content: "";
  width: 0;
  height: 1px;
  background: #89712f;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  transition: width 200ms cubic-bezier(0.65, 0, 0.35, 1);
}
@media screen and (max-width: 1023px) {
header .gnavi li a[data-v-7653fc8a]:before {
    height: auto;
    left: 0;
    bottom: auto;
    top: 0;
    position: relative;
}
}
header .gnavi li a[data-v-7653fc8a]:after {
  content: attr(data-eng);
  font-size: 0.88rem;
  display: block;
  text-align: center;
}
header .gnavi li a svg[data-v-7653fc8a] {
  width: 1.1rem;
  height: 1.1rem;
  fill: #fafbf6;
  display: inline-block;
  margin: 0 0 0 0.32rem;
  transition: fill 200ms cubic-bezier(0.65, 0, 0.35, 1);
}
header .gnavi li a[data-v-7653fc8a]:hover {
  color: #89712f;
}
@media screen and (max-width: 1023px) {
header .gnavi li a[data-v-7653fc8a]:hover {
    color: #fafbf6;
}
}
header .gnavi li a:hover svg[data-v-7653fc8a] {
  fill: #89712f;
}
@media screen and (max-width: 1023px) {
header .gnavi li a:hover svg[data-v-7653fc8a] {
    fill: #fafbf6;
}
}
header .gnavi li a[data-v-7653fc8a]:hover:before {
  width: 100%;
}
header .other[data-v-7653fc8a] {
  position: fixed;
  top: 0;
  right: calc(6.4rem - 1px);
  height: 6.4rem;
  background: rgb(56.8, 75.2, 6.4);
  color: #f1f2ed;
  line-height: 1.5;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  padding: 0 2rem;
  z-index: 900;
  border-radius: 0 0 0 1rem;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  transition: clip-path 800ms cubic-bezier(0.65, 0, 0.35, 1), background 400ms cubic-bezier(0.65, 0, 0.35, 1);
}
header .other.pc[data-v-7653fc8a] {
  right: 0;
}
@media screen and (max-width: 769px) {
header .other[data-v-7653fc8a] {
    right: calc(4.8rem - 1px);
    height: 4.8rem;
    padding: 0 1.6rem;
}
}
header .other.active[data-v-7653fc8a] {
  clip-path: polygon(100% 0, 100% 0, 100% 100%, 100% 0);
}
header .other[data-v-7653fc8a]:hover {
  background: #89712f;
}
header .other div[data-v-7653fc8a] {
  font-size: 0.72rem;
  text-align: center;
}
@media screen and (max-width: 769px) {
header .other div[data-v-7653fc8a] {
    font-size: 0.72rem;
    padding: 0.32rem 0;
}
}
header .other div svg[data-v-7653fc8a] {
  width: 2.4rem;
  fill: #f1f2ed;
  display: block;
  margin: 0 auto 0.32rem;
}
@media screen and (max-width: 769px) {
header .other div svg[data-v-7653fc8a] {
    width: 1.4rem;
    margin-bottom: 0.4rem;
}
}
header .lang[data-v-7653fc8a] {
  position: absolute;
  top: 1rem;
  right: 16rem;
  overflow: hidden;
  display: grid;
  grid-template-columns: auto 1fr;
  border-radius: 999rem;
  background: #fafbf6;
}
@media screen and (max-width: 769px) {
header .lang[data-v-7653fc8a] {
    right: calc(var(--size) + 2vw);
    top: 6rem;
}
}
header .lang.pc[data-v-7653fc8a] {
  top: 2rem;
  right: 10rem;
}
header .lang > svg[data-v-7653fc8a] {
  fill: #24271c;
  position: absolute;
  right: 0.64rem;
  top: 50%;
  transform: translateY(-50%);
  width: 1.2rem;
}
header .lang span[data-v-7653fc8a] {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafbf6;
  padding: 0 0.4rem;
}
header .lang span svg[data-v-7653fc8a] {
  width: 1.6rem;
  fill: #475e08;
}
header .lang select[data-v-7653fc8a] {
  font-family: "Yu Gothic", "游ゴシック", YuGothic, "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, "MS Pゴシック", Helvetica, Arial, Verdana, sans-serif;
  font-weight: 500;
  font-size: 1rem;
  -webkit-font-feature-settings: "palt";
  font-feature-settings: "palt";
  letter-spacing: 0.024em;
  font-size: 1.04rem;
  line-height: 1.5;
  padding: 0.4rem 0;
  padding-right: 2rem;
  border: none;
  color: #24271c;
  background: transparent;
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
}
header .trg[data-v-7653fc8a] {
  position: fixed;
  top: 0;
  right: 0;
  width: 6.4rem;
  height: 6.4rem;
  cursor: pointer;
  overflow: hidden;
  z-index: 1000;
}
@media screen and (max-width: 769px) {
header .trg[data-v-7653fc8a] {
    width: 4.8rem;
    height: 4.8rem;
}
}
header .trg[data-v-7653fc8a]:before, header .trg[data-v-7653fc8a]:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #475e08;
  z-index: -1;
}
header .trg[data-v-7653fc8a]:after {
  width: 0;
  left: auto;
  right: 0;
  background: #191b13;
  transition: all 320ms cubic-bezier(0.65, 0, 0.35, 1);
}
header .trg[data-v-7653fc8a]:hover:after {
  width: 100%;
  left: 0;
  right: auto;
}
header .trg.active[data-v-7653fc8a]:after {
  width: 100%;
}
header .trg.active[data-v-7653fc8a]:hover:after {
  background: #24271c;
}
header .trg.active i[data-v-7653fc8a] {
  width: 0;
}
header .trg.active i[data-v-7653fc8a]:first-of-type, header .trg.active i[data-v-7653fc8a]:last-of-type {
  width: 40%;
  top: 50%;
}
header .trg.active i[data-v-7653fc8a]:first-of-type {
  transform: translate(-50%) rotate(45deg);
}
header .trg.active i[data-v-7653fc8a]:last-of-type {
  transform: translate(-50%) rotate(-45deg);
}
header .trg i[data-v-7653fc8a] {
  width: 33%;
  height: 1px;
  background: #fafbf6;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%);
  transition: all 320ms cubic-bezier(0.65, 0, 0.35, 1);
}
header .trg i[data-v-7653fc8a]:first-of-type {
  top: calc(50% - 0.5rem);
}
header .trg i[data-v-7653fc8a]:last-of-type {
  top: calc(50% + 0.5rem);
}
header .fix[data-v-7653fc8a] {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #475e08;
}
@media screen and (max-width: 1023px) {
header .fix[data-v-7653fc8a] {
    overflow: auto;
}
}
header nav[data-v-7653fc8a] {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9;
  background: #475e08 url(/images/common/texture.webp) repeat left top/250px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 769px) {
header nav[data-v-7653fc8a] {
    overflow: auto;
    display: grid;
    grid-template-columns: 1fr;
}
header nav[data-v-7653fc8a] > * {
    align-self: flex-start;
}
}
header nav .logo[data-v-7653fc8a] {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}
header nav .pics[data-v-7653fc8a] {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  display: grid;
}
@media screen and (max-width: 1023px) {
header nav .pics[data-v-7653fc8a] {
    width: 100%;
    height: 30%;
    grid-template-rows: 1fr;
}
}
@media screen and (max-width: 769px) {
header nav .pics[data-v-7653fc8a] {
    height: 25%;
}
}
header nav .pics figure[data-v-7653fc8a] {
  position: relative;
  overflow: hidden;
}
header nav .pics figure[data-v-7653fc8a]:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  background: #475e08 url(/images/common/texture.webp) repeat left top/250px;
  z-index: 2;
}
@media screen and (max-width: 769px) {
header nav .pics figure[data-v-7653fc8a]:before {
    display: none;
}
}
header nav .pics figure[data-v-7653fc8a]:nth-of-type(odd):before {
  left: 0;
  right: auto;
}
header nav .pics figure img[data-v-7653fc8a] {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  position: relative;
}
header nav .pics.active figure[data-v-7653fc8a]:before {
  animation: menuPicBefore-7653fc8a 800ms 200ms cubic-bezier(0.65, 0, 0.35, 1) forwards;
}
header nav .pics.active figure img[data-v-7653fc8a] {
  animation: menuPic-7653fc8a 1200ms cubic-bezier(0.65, 0, 0.35, 1) forwards;
}
@keyframes menuPicBefore-7653fc8a {
0% {
    width: 100%;
}
100% {
    width: 0;
}
}
@keyframes menuPic-7653fc8a {
0% {
    transform: scale(1.1);
}
100% {
    transform: scale(1);
}
}
header nav .menu[data-v-7653fc8a] {
  width: 50%;
  height: 100%;
  padding: 0 0 5.6rem;
  position: absolute;
  background: url(/images/common/menu_circle.webp) no-repeat left top/80%;
  left: 0;
  top: 0;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 1023px) {
header nav .menu[data-v-7653fc8a] {
    width: 100%;
    height: 70%;
    top: auto;
    bottom: 0;
}
}
@media screen and (max-width: 769px) {
header nav .menu[data-v-7653fc8a] {
    display: grid;
    grid-template-rows: 2fr;
    order: 2;
    height: 75%;
    align-self: center;
}
}
header nav .menu ul[data-v-7653fc8a] {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 2.4rem;
  grid-row-gap: 2.4rem;
  margin: 4rem 0 0;
}
@media screen and (max-width: 1023px) {
header nav .menu ul[data-v-7653fc8a] {
    grid-column-gap: calc(var(--size) + 2vw);
    grid-row-gap: 2rem;
    margin: 0;
}
}
@media screen and (max-width: 769px) {
header nav .menu ul[data-v-7653fc8a] {
    grid-template-columns: repeat(2, 1fr);
    padding: 3.2rem calc(var(--size) + 2vw) 1.6rem;
    text-align: center;
}
}
header nav .menu ul.active li[data-v-7653fc8a] {
  animation: showMenuList-7653fc8a 600ms ease-in-out forwards;
}
header nav .menu ul.active li[data-v-7653fc8a]:nth-child(1) {
  animation-delay: 440ms;
}
header nav .menu ul.active li[data-v-7653fc8a]:nth-child(2) {
  animation-delay: 480ms;
}
header nav .menu ul.active li[data-v-7653fc8a]:nth-child(3) {
  animation-delay: 520ms;
}
header nav .menu ul.active li[data-v-7653fc8a]:nth-child(4) {
  animation-delay: 560ms;
}
header nav .menu ul.active li[data-v-7653fc8a]:nth-child(5) {
  animation-delay: 600ms;
}
header nav .menu ul.active li[data-v-7653fc8a]:nth-child(6) {
  animation-delay: 640ms;
}
header nav .menu ul.active li[data-v-7653fc8a]:nth-child(7) {
  animation-delay: 680ms;
}
header nav .menu ul.active li[data-v-7653fc8a]:nth-child(8) {
  animation-delay: 720ms;
}
header nav .menu ul.active li[data-v-7653fc8a]:nth-child(9) {
  animation-delay: 760ms;
}
header nav .menu ul.active li[data-v-7653fc8a]:nth-child(10) {
  animation-delay: 800ms;
}
@keyframes showMenuList-7653fc8a {
0% {
    transform: translateY(2.4rem);
    opacity: 0;
}
100% {
    transform: translateY(0);
    opacity: 1;
}
}
header nav .menu ul li[data-v-7653fc8a] {
  line-height: 1;
  opacity: 0;
}
header nav .menu ul li a[data-v-7653fc8a] {
  font-size: 3.72vmin;
  letter-spacing: 0.12rem;
  line-height: 1;
  color: #fafbf6;
  fill: #fafbf6;
  display: inline-block;
  position: relative;
  padding: 0.4rem;
  z-index: 1;
}
@media screen and (max-width: 769px) {
header nav .menu ul li a[data-v-7653fc8a] {
    font-size: 4.2vmin;
}
}
header nav .menu ul li a[data-v-7653fc8a]:before {
  content: attr(data-eng);
  display: block;
  font-size: 1.6vmin;
  margin: 0 0 0.8rem 0.24rem;
  letter-spacing: 0.08;
  white-space: nowrap;
}
@media screen and (max-width: 769px) {
header nav .menu ul li a[data-v-7653fc8a]:before {
    font-size: 3.2vmin;
    letter-spacing: 0.012vmin;
    margin: 0 0 0.64rem;
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    background: none;
    transform: translateX(0);
}
}
header nav .menu ul li a[data-v-7653fc8a]:after {
  content: "";
  width: 0;
  height: 100%;
  background: #89712f;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  transition: width 320ms cubic-bezier(0.65, 0, 0.35, 1);
  z-index: -1;
}
@media screen and (max-width: 1023px) {
header nav .menu ul li a[data-v-7653fc8a]:after {
    display: none;
}
}
header nav .menu ul li a[data-v-7653fc8a]:hover:after {
  width: 100%;
  left: 0;
  right: auto;
}
header nav .menu ul li a svg[data-v-7653fc8a] {
  width: 3.4vmin;
  height: 3.4vmin;
  display: inline-block;
  margin: 0 0 0 0.8vmin;
  transform: translateY(0.33vmin);
}
@media screen and (max-width: 769px) {
header nav .menu ul li a svg[data-v-7653fc8a] {
    width: 5vmin;
    height: 5vmin;
    transform: translateY(25%);
}
}
header nav .meta[data-v-7653fc8a] {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
  color: #fafbf6;
  fill: #fafbf6;
  padding: 1.6rem calc(var(--size) + 2vw);
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 2rem;
}
@media screen and (max-width: 769px) {
header nav .meta[data-v-7653fc8a] {
    width: 100vw;
    position: relative;
    top: 0;
    left: 0;
    right: auto;
    bottom: auto;
    align-self: flex-end;
    grid-template-columns: 1fr;
    gap: 1rem;
}
}
header nav .meta[data-v-7653fc8a] > * {
  align-self: center;
}
@media screen and (max-width: 769px) {
header nav .meta[data-v-7653fc8a] > * {
    justify-self: center;
}
}
header nav .meta dt[data-v-7653fc8a] {
  font-size: 0.92rem;
  line-height: 1.6;
  text-align: justify;
}
@media screen and (max-width: 769px) {
header nav .meta dt[data-v-7653fc8a] {
    font-size: 0.96rem;
    text-align: center;
}
}
header nav .meta dd[data-v-7653fc8a] {
  font-size: 1.24rem;
  line-height: 1.4;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  gap: 0.64rem;
}
@media screen and (max-width: 769px) {
header nav .meta dd[data-v-7653fc8a] {
    font-size: 1.32rem;
    display: block;
    line-height: 1.8;
}
}
header nav .meta dd svg[data-v-7653fc8a] {
  width: 2.32rem;
  height: 2.32rem;
}`, "",{"version":3,"sources":["webpack://./headers.vue","webpack://./src/scss/module/_module.scss","webpack://./src/js/components/headers.vue"],"names":[],"mappings":"AAAA,gBAAgB;ACEhB;6DAAA;AAgBA;6DAAA;AAOA;6DAAA;AAEA;EACC,sDAAA;EACA,OAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACC,aAAA;EACA,YAAA;ADlBF;ACmBC;AARD;IASE,eAAA;ADhBA;AACF;ACiBC;AAXD;IAYE,eAAA;IACE,YAAA;ADdF;AACF;ACeC;AAfD;IAgBE,iBAAA;IACE,YAAA;ADZF;AACF;AC0FA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ADvFD;ACyFA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ADvFD;ACyFA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ADvFD;ACyFA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ADvFD;ACyFA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ADvFD;ACyFA;EACC,wBAAA;EACA,4BAAA;EACA,iBAAA;ADvFD;AE7DA;;EAEE,uDAAA;AF+DF;AE7DA;;EAEE,UAAA;AFgEF;AE9DA;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,gCAAA;EACA,aAAA;AFiEF;AEhEE;AATF;IAUI,kBAAA;AFmEF;AACF;AEjEI;EACE,aAAA;EACA,YAAA;AFmEN;AEhEE;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,4DAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;AFkEJ;AEhEE;EACE,0CAAA;EACA,cAAA;EACA,wBAAA;AFkEJ;AEjEI;AAJF;IAKI,YAAA;AFoEJ;AACF;AEnEI;EACE,WAAA;AFqEN;AElEE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AFoEJ;AEnEI;AARF;IASI,MAAA;IACA,mBAAA;AFsEJ;AACF;AErEI;EACE,oBAAA;AFuEN;AEtEM;AAFF;IAGI,SAAA;AFyEN;AACF;AExEM;EACE,SAAA;AF0ER;AExEM;EACE,kBAAA;EACA,cDnEA;ECoEA,kBAAA;EACA,sDAAA;AF0ER;AEzEQ;EACE,WAAA;EACA,QAAA;EACA,WAAA;EACA,mBDnEH;ECoEG,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,sDAAA;AF2EV;AE1EU;AAVF;IAWI,YAAA;IACA,OAAA;IACA,YAAA;IACA,MAAA;IACA,kBAAA;AF6EV;AACF;AE3EQ;EACE,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AF6EV;AE3EQ;EACE,aAAA;EACA,cAAA;EACA,aDjGF;ECkGE,qBAAA;EACA,qBAAA;EACA,qDAAA;AF6EV;AE3EQ;EACE,cDhGH;AD6KP;AE5EU;AAFF;IAGI,cDzGJ;ADwLN;AACF;AE9EU;EACE,aDrGL;ADqLP;AE/EY;AAFF;IAGI,aD9GN;ADgMN;AACF;AEhFU;EACE,WAAA;AFkFZ;AE5EE;EACE,eAAA;EACA,MAAA;EACA,yBAAA;EACA,cAAA;EACA,gCAAA;EACA,cD5HG;EC6HH,gBAAA;EDrFH,aAAA;EACA,mBAAA;EACA,8BAHiC;EAIhC,iBAAA;ECoFE,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kDAAA;EACA,2GAAA;AFiFJ;AEhFI;EACE,QAAA;AFkFN;AEhFI;AAnBF;IAoBI,yBAAA;IACA,cAlJG;IAmJH,iBAAA;AFmFJ;AACF;AElFI;EACE,qDAAA;AFoFN;AElFI;EACE,mBD7IC;ADiOP;AElFI;EACE,kBAAA;EACA,kBAAA;AFoFN;AEnFM;AAHF;IAII,kBAAA;IACA,kBAAA;AFsFN;AACF;AErFM;EACE,aAAA;EACA,aD7JD;EC8JC,cAAA;EACA,sBAAA;AFuFR;AEtFQ;AALF;IAMI,aAAA;IACA,qBAAA;AFyFR;AACF;AErFE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBDjLI;ADwQR;AEtFI;AATF;IAUI,8BAAA;IACA,SAAA;AFyFJ;AACF;AExFI;EACE,SAAA;EACA,YAAA;AF0FN;AExFI;EACE,aD9LG;EC+LH,kBAAA;EACA,cAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;AF0FN;AExFI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBDtME;ECuMF,iBAAA;AF0FN;AEzFM;EACE,aAAA;EACA,aDrMD;ADgSP;AExFI;EDzDH,0IAAA;EACA,gBAAA;EACC,eAAA;EACD,qCAAA;EACA,6BAAA;EACA,uBAAA;ECsDK,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,cDvNG;ECwNH,uBAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;AF+FN;AE5FE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AF8FJ;AE7FI;AATF;IAUI,aA1OG;IA2OH,cA3OG;AF2UP;AACF;AE/FI;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBD3OC;EC4OD,WAAA;AFgGN;AE9FI;EACE,QAAA;EACA,UAAA;EACA,QAAA;EACA,mBDtPE;ECuPF,oDAAA;AFgGN;AE7FM;EACE,WAAA;EACA,OAAA;EACA,WAAA;AF+FR;AE3FM;EACE,WAAA;AF6FR;AE1FQ;EACE,mBD1QD;ADsWT;AEzFM;EACE,QAAA;AF2FR;AE1FQ;EAEE,UAAA;EACA,QAAA;AF2FV;AEzFQ;EACE,wCAAA;AF2FV;AEzFQ;EACE,yCAAA;AF2FV;AEvFI;EACE,UAAA;EACA,WAAA;EACA,mBD5RE;EC6RF,kBAAA;EACA,QAAA;EACA,SAAA;EACA,0BAAA;EACA,oDAAA;AFyFN;AExFM;EACE,uBAAA;AF0FR;AExFM;EACE,uBAAA;AF0FR;AEtFE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,mBD3SG;ADmYP;AEvFI;AAPF;IAQI,cAAA;AF0FJ;AACF;AExFE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EDjNA,0EAAA;EAhEH,aAAA;EACA,mBAAA;EACA,8BAHiC;EAIhC,iBAAA;ECiRE,mBAAA;EACA,uBAAA;AF6FJ;AE5FI;AAXF;IAYI,cAAA;IACA,aAAA;IACA,0BAAA;AF+FJ;AE9FI;IACE,sBAAA;AFgGN;AACF;AE9FI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AFgGN;AE9FI;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;AFgGN;AE/FM;AAPF;IAQI,WAAA;IACA,WAAA;IACA,uBAAA;AFkGN;AACF;AEjGM;AAZF;IAaI,WAAA;AFoGN;AACF;AEnGM;EACE,kBAAA;EACA,gBAAA;AFqGR;AEpGQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,QAAA;ED5PN,0EAAA;EC8PM,UAAA;AFsGV;AErGU;AATF;IAUI,aAAA;AFwGV;AACF;AErGU;EACE,OAAA;EACA,WAAA;AFuGZ;AEpGQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AFsGV;AEjGU;EACE,qFAAA;AFmGZ;AEjGU;EACE,0EAAA;AFmGZ;AEjGU;AACE;IACE,WAAA;AFmGZ;AEjGU;IACE,QAAA;AFmGZ;AACF;AEjGU;AACE;IACE,qBAAA;AFmGZ;AEjGU;IACE,mBAAA;AFmGZ;AACF;AE9FI;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,uEAAA;EACA,OAAA;EACA,MAAA;EDnXL,aAAA;EACA,mBAAA;EACA,8BAHiC;EAIhC,iBAAA;ECkXI,mBAAA;EACA,uBAAA;AFmGN;AElGM;AAXF;IAYI,WAAA;IACA,WAAA;IACA,SAAA;IACA,SAAA;AFqGN;AACF;AEpGM;AAjBF;IAkBI,aAAA;IACA,uBAAA;IACA,QAAA;IACA,WAAA;IACA,kBAAA;AFuGN;AACF;AEtGM;EACE,aAAA;EACA,qCAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;AFwGR;AEvGQ;AANF;IAOI,wCAAA;IACA,kBAAA;IACA,SAAA;AF0GR;AACF;AEzGQ;AAXF;IAYI,qCAAA;IACA,8CAAA;IACA,kBAAA;AF4GR;AACF;AE1GU;EACE,2DAAA;AF4GZ;AE1Gc;EACE,sBAAA;AF4GhB;AE7Gc;EACE,sBAAA;AF+GhB;AEhHc;EACE,sBAAA;AFkHhB;AEnHc;EACE,sBAAA;AFqHhB;AEtHc;EACE,sBAAA;AFwHhB;AEzHc;EACE,sBAAA;AF2HhB;AE5Hc;EACE,sBAAA;AF8HhB;AE/Hc;EACE,sBAAA;AFiIhB;AElIc;EACE,sBAAA;AFoIhB;AErIc;EACE,sBAAA;AFuIhB;AEpIY;AACE;IACE,6BAAA;IACA,UAAA;AFsId;AEpIY;IACE,wBAAA;IACA,UAAA;AFsId;AACF;AElIQ;EACE,cAAA;EACA,UAAA;AFoIV;AEnIU;EACE,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cDzdJ;EC0dI,aD1dJ;EC2dI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AFqIZ;AEpIY;AAVF;IAWI,kBAAA;AFuIZ;AACF;AEtIY;EACE,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,mBAAA;AFwId;AEvIc;AAPF;IAQI,kBAAA;IACA,yBAAA;IACA,mBAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,gBAAA;IACA,wBAAA;AF0Id;AACF;AExIY;EACE,WAAA;EACA,QAAA;EACA,YAAA;EACA,mBDlfP;ECmfO,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,sDAAA;EACA,WAAA;AF0Id;AEzIc;AAXF;IAYI,aAAA;AF4Id;AACF;AEzIc;EACE,WAAA;EACA,OAAA;EACA,WAAA;AF2IhB;AExIY;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,+BAAA;AF0Id;AEzIc;AANF;IAOI,YAAA;IACA,aAAA;IACA,0BAAA;AF4Id;AACF;AEtII;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cDhiBE;ECiiBF,aDjiBE;ECkiBF,uCAAA;EACA,aAAA;EACA,+BAAA;EACA,qBAAA;AFwIN;AEvIM;AAXF;IAYI,YAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,oBAAA;IACA,0BAAA;IACA,SAAA;AF0IN;AACF;AEzIM;EACE,kBAAA;AF2IR;AE1IQ;AAFF;IAGI,oBAAA;AF6IR;AACF;AE3IM;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AF6IR;AE5IQ;AAJF;IAKI,kBAAA;IACA,kBAAA;AF+IR;AACF;AE7IM;EACE,kBAAA;EACA,gBAAA;EDxhBP,aAAA;EACA,mBAAA;EACA,8BAHiC;EAIhC,iBAAA;ECuhBM,2BAAA;EACA,mBAAA;EACA,YAAA;AFkJR;AEjJQ;AAPF;IAQI,kBAAA;IACA,cAAA;IACA,gBAAA;AFoJR;AACF;AEnJQ;EACE,cAAA;EACA,eAAA;AFqJV","sourcesContent":["@charset \"UTF-8\";\n@import url(\"https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz@0,6..96;1,6..96&display=swap\");\n/* BASE COLOR\n------------------------------------------------------------*/\n/* DISPLAY SETTING\n------------------------------------------------------------*/\n/* OTHER SETTING\n------------------------------------------------------------*/\n:root {\n  font-size: calc(14.5px + 1.5 * (100vw - 1440px) / 480);\n  --cx: 0;\n  --cy: 0;\n  --vw: 100vw;\n  --vh: 100vh;\n  --screen: 0px;\n  --size: 32px;\n}\n@media screen and (min-width: 1920px) {\n  :root {\n    font-size: 16px;\n  }\n}\n@media screen and (max-width: 1023px) {\n  :root {\n    font-size: 14px;\n    --size: 16px;\n  }\n}\n@media screen and (max-width: 769px) {\n  :root {\n    font-size: 13.5px;\n    --size: 10px;\n  }\n}\n\n@font-face {\n  font-family: \"Yu Gothic\";\n  src: local(\"Yu Gothic Medium\");\n  font-weight: 100;\n}\n@font-face {\n  font-family: \"Yu Gothic\";\n  src: local(\"Yu Gothic Medium\");\n  font-weight: 200;\n}\n@font-face {\n  font-family: \"Yu Gothic\";\n  src: local(\"Yu Gothic Medium\");\n  font-weight: 300;\n}\n@font-face {\n  font-family: \"Yu Gothic\";\n  src: local(\"Yu Gothic Medium\");\n  font-weight: 400;\n}\n@font-face {\n  font-family: \"Yu Gothic\";\n  src: local(\"Yu Gothic Medium\");\n  font-weight: 500;\n}\n@font-face {\n  font-family: \"Yu Gothic\";\n  src: local(\"Yu Gothic Bold\");\n  font-weight: bold;\n}\n.nav-enter-active,\n.nav-leave-active {\n  transition: opacity 0.5s cubic-bezier(0.65, 0, 0.35, 1);\n}\n\n.nav-enter-from,\n.nav-leave-to {\n  opacity: 0;\n}\n\nheader {\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: auto auto;\n  z-index: 1000;\n}\n@media screen and (max-width: 769px) {\n  header {\n    position: absolute;\n  }\n}\nheader.pc:before {\n  height: 25dvh;\n  opacity: 0.8;\n}\nheader:before {\n  content: \"\";\n  width: 100%;\n  height: 15dvh;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0), black);\n  opacity: 0.4;\n  pointer-events: none;\n  z-index: -1;\n}\nheader .logo {\n  margin: 1.2rem 0 0 calc(var(--size) + 2vw);\n  width: 14.4rem;\n  justify-self: flex-start;\n}\n@media screen and (max-width: 769px) {\n  header .logo {\n    width: 10rem;\n  }\n}\nheader .logo img {\n  width: 100%;\n}\nheader .gnavi {\n  position: absolute;\n  top: 1.6rem;\n  left: 50%;\n  transform: translate(-50%, 0);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media screen and (max-width: 1023px) {\n  header .gnavi {\n    top: 0;\n    min-height: 100vmax;\n  }\n}\nheader .gnavi li {\n  margin: 0 0 0 2.4rem;\n}\n@media screen and (max-width: 1023px) {\n  header .gnavi li {\n    margin: 0;\n  }\n}\nheader .gnavi li:first-child {\n  margin: 0;\n}\nheader .gnavi li a {\n  font-size: 1.08rem;\n  color: #fafbf6;\n  position: relative;\n  transition: color 200ms cubic-bezier(0.65, 0, 0.35, 1);\n}\nheader .gnavi li a:before {\n  content: \"\";\n  width: 0;\n  height: 1px;\n  background: #89712f;\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  transform: translateX(-50%);\n  transition: width 200ms cubic-bezier(0.65, 0, 0.35, 1);\n}\n@media screen and (max-width: 1023px) {\n  header .gnavi li a:before {\n    height: auto;\n    left: 0;\n    bottom: auto;\n    top: 0;\n    position: relative;\n  }\n}\nheader .gnavi li a:after {\n  content: attr(data-eng);\n  font-size: 0.88rem;\n  display: block;\n  text-align: center;\n}\nheader .gnavi li a svg {\n  width: 1.1rem;\n  height: 1.1rem;\n  fill: #fafbf6;\n  display: inline-block;\n  margin: 0 0 0 0.32rem;\n  transition: fill 200ms cubic-bezier(0.65, 0, 0.35, 1);\n}\nheader .gnavi li a:hover {\n  color: #89712f;\n}\n@media screen and (max-width: 1023px) {\n  header .gnavi li a:hover {\n    color: #fafbf6;\n  }\n}\nheader .gnavi li a:hover svg {\n  fill: #89712f;\n}\n@media screen and (max-width: 1023px) {\n  header .gnavi li a:hover svg {\n    fill: #fafbf6;\n  }\n}\nheader .gnavi li a:hover:before {\n  width: 100%;\n}\nheader .other {\n  position: fixed;\n  top: 0;\n  right: calc(6.4rem - 1px);\n  height: 6.4rem;\n  background: rgb(56.8, 75.2, 6.4);\n  color: #f1f2ed;\n  line-height: 1.5;\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n  padding: 0 2rem;\n  z-index: 900;\n  border-radius: 0 0 0 1rem;\n  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n  transition: clip-path 800ms cubic-bezier(0.65, 0, 0.35, 1), background 400ms cubic-bezier(0.65, 0, 0.35, 1);\n}\nheader .other.pc {\n  right: 0;\n}\n@media screen and (max-width: 769px) {\n  header .other {\n    right: calc(4.8rem - 1px);\n    height: 4.8rem;\n    padding: 0 1.6rem;\n  }\n}\nheader .other.active {\n  clip-path: polygon(100% 0, 100% 0, 100% 100%, 100% 0);\n}\nheader .other:hover {\n  background: #89712f;\n}\nheader .other div {\n  font-size: 0.72rem;\n  text-align: center;\n}\n@media screen and (max-width: 769px) {\n  header .other div {\n    font-size: 0.72rem;\n    padding: 0.32rem 0;\n  }\n}\nheader .other div svg {\n  width: 2.4rem;\n  fill: #f1f2ed;\n  display: block;\n  margin: 0 auto 0.32rem;\n}\n@media screen and (max-width: 769px) {\n  header .other div svg {\n    width: 1.4rem;\n    margin-bottom: 0.4rem;\n  }\n}\nheader .lang {\n  position: absolute;\n  top: 1rem;\n  right: 16rem;\n  overflow: hidden;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  border-radius: 999rem;\n  background: #fafbf6;\n}\n@media screen and (max-width: 769px) {\n  header .lang {\n    right: calc(var(--size) + 2vw);\n    top: 6rem;\n  }\n}\nheader .lang.pc {\n  top: 2rem;\n  right: 10rem;\n}\nheader .lang > svg {\n  fill: #24271c;\n  position: absolute;\n  right: 0.64rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 1.2rem;\n}\nheader .lang span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fafbf6;\n  padding: 0 0.4rem;\n}\nheader .lang span svg {\n  width: 1.6rem;\n  fill: #475e08;\n}\nheader .lang select {\n  font-family: \"Yu Gothic\", \"游ゴシック\", YuGothic, \"Hiragino Kaku Gothic Pro\", \"メイリオ\", Meiryo, \"MS Pゴシック\", Helvetica, Arial, Verdana, sans-serif;\n  font-weight: 500;\n  font-size: 1rem;\n  -webkit-font-feature-settings: \"palt\";\n  font-feature-settings: \"palt\";\n  letter-spacing: 0.024em;\n  font-size: 1.04rem;\n  line-height: 1.5;\n  padding: 0.4rem 0;\n  padding-right: 2rem;\n  border: none;\n  color: #24271c;\n  background: transparent;\n  -webkit-appearance: none;\n  appearance: none;\n  cursor: pointer;\n}\nheader .trg {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 6.4rem;\n  height: 6.4rem;\n  cursor: pointer;\n  overflow: hidden;\n  z-index: 1000;\n}\n@media screen and (max-width: 769px) {\n  header .trg {\n    width: 4.8rem;\n    height: 4.8rem;\n  }\n}\nheader .trg:before, header .trg:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #475e08;\n  z-index: -1;\n}\nheader .trg:after {\n  width: 0;\n  left: auto;\n  right: 0;\n  background: #191b13;\n  transition: all 320ms cubic-bezier(0.65, 0, 0.35, 1);\n}\nheader .trg:hover:after {\n  width: 100%;\n  left: 0;\n  right: auto;\n}\nheader .trg.active:after {\n  width: 100%;\n}\nheader .trg.active:hover:after {\n  background: #24271c;\n}\nheader .trg.active i {\n  width: 0;\n}\nheader .trg.active i:first-of-type, header .trg.active i:last-of-type {\n  width: 40%;\n  top: 50%;\n}\nheader .trg.active i:first-of-type {\n  transform: translate(-50%) rotate(45deg);\n}\nheader .trg.active i:last-of-type {\n  transform: translate(-50%) rotate(-45deg);\n}\nheader .trg i {\n  width: 33%;\n  height: 1px;\n  background: #fafbf6;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%);\n  transition: all 320ms cubic-bezier(0.65, 0, 0.35, 1);\n}\nheader .trg i:first-of-type {\n  top: calc(50% - 0.5rem);\n}\nheader .trg i:last-of-type {\n  top: calc(50% + 0.5rem);\n}\nheader .fix {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: #475e08;\n}\n@media screen and (max-width: 1023px) {\n  header .fix {\n    overflow: auto;\n  }\n}\nheader nav {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 9;\n  background: #475e08 url(/images/common/texture.webp) repeat left top/250px;\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n}\n@media screen and (max-width: 769px) {\n  header nav {\n    overflow: auto;\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n  header nav > * {\n    align-self: flex-start;\n  }\n}\nheader nav .logo {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\nheader nav .pics {\n  width: 50%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: grid;\n}\n@media screen and (max-width: 1023px) {\n  header nav .pics {\n    width: 100%;\n    height: 30%;\n    grid-template-rows: 1fr;\n  }\n}\n@media screen and (max-width: 769px) {\n  header nav .pics {\n    height: 25%;\n  }\n}\nheader nav .pics figure {\n  position: relative;\n  overflow: hidden;\n}\nheader nav .pics figure:before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  right: 0;\n  background: #475e08 url(/images/common/texture.webp) repeat left top/250px;\n  z-index: 2;\n}\n@media screen and (max-width: 769px) {\n  header nav .pics figure:before {\n    display: none;\n  }\n}\nheader nav .pics figure:nth-of-type(odd):before {\n  left: 0;\n  right: auto;\n}\nheader nav .pics figure img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  position: relative;\n}\nheader nav .pics.active figure:before {\n  animation: menuPicBefore 800ms 200ms cubic-bezier(0.65, 0, 0.35, 1) forwards;\n}\nheader nav .pics.active figure img {\n  animation: menuPic 1200ms cubic-bezier(0.65, 0, 0.35, 1) forwards;\n}\n@keyframes menuPicBefore {\n  0% {\n    width: 100%;\n  }\n  100% {\n    width: 0;\n  }\n}\n@keyframes menuPic {\n  0% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\nheader nav .menu {\n  width: 50%;\n  height: 100%;\n  padding: 0 0 5.6rem;\n  position: absolute;\n  background: url(/images/common/menu_circle.webp) no-repeat left top/80%;\n  left: 0;\n  top: 0;\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n}\n@media screen and (max-width: 1023px) {\n  header nav .menu {\n    width: 100%;\n    height: 70%;\n    top: auto;\n    bottom: 0;\n  }\n}\n@media screen and (max-width: 769px) {\n  header nav .menu {\n    display: grid;\n    grid-template-rows: 2fr;\n    order: 2;\n    height: 75%;\n    align-self: center;\n  }\n}\nheader nav .menu ul {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 2.4rem;\n  grid-row-gap: 2.4rem;\n  margin: 4rem 0 0;\n}\n@media screen and (max-width: 1023px) {\n  header nav .menu ul {\n    grid-column-gap: calc(var(--size) + 2vw);\n    grid-row-gap: 2rem;\n    margin: 0;\n  }\n}\n@media screen and (max-width: 769px) {\n  header nav .menu ul {\n    grid-template-columns: repeat(2, 1fr);\n    padding: 3.2rem calc(var(--size) + 2vw) 1.6rem;\n    text-align: center;\n  }\n}\nheader nav .menu ul.active li {\n  animation: showMenuList 600ms ease-in-out forwards;\n}\nheader nav .menu ul.active li:nth-child(1) {\n  animation-delay: 440ms;\n}\nheader nav .menu ul.active li:nth-child(2) {\n  animation-delay: 480ms;\n}\nheader nav .menu ul.active li:nth-child(3) {\n  animation-delay: 520ms;\n}\nheader nav .menu ul.active li:nth-child(4) {\n  animation-delay: 560ms;\n}\nheader nav .menu ul.active li:nth-child(5) {\n  animation-delay: 600ms;\n}\nheader nav .menu ul.active li:nth-child(6) {\n  animation-delay: 640ms;\n}\nheader nav .menu ul.active li:nth-child(7) {\n  animation-delay: 680ms;\n}\nheader nav .menu ul.active li:nth-child(8) {\n  animation-delay: 720ms;\n}\nheader nav .menu ul.active li:nth-child(9) {\n  animation-delay: 760ms;\n}\nheader nav .menu ul.active li:nth-child(10) {\n  animation-delay: 800ms;\n}\n@keyframes showMenuList {\n  0% {\n    transform: translateY(2.4rem);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\nheader nav .menu ul li {\n  line-height: 1;\n  opacity: 0;\n}\nheader nav .menu ul li a {\n  font-size: 3.72vmin;\n  letter-spacing: 0.12rem;\n  line-height: 1;\n  color: #fafbf6;\n  fill: #fafbf6;\n  display: inline-block;\n  position: relative;\n  padding: 0.4rem;\n  z-index: 1;\n}\n@media screen and (max-width: 769px) {\n  header nav .menu ul li a {\n    font-size: 4.2vmin;\n  }\n}\nheader nav .menu ul li a:before {\n  content: attr(data-eng);\n  display: block;\n  font-size: 1.6vmin;\n  margin: 0 0 0.8rem 0.24rem;\n  letter-spacing: 0.08;\n  white-space: nowrap;\n}\n@media screen and (max-width: 769px) {\n  header nav .menu ul li a:before {\n    font-size: 3.2vmin;\n    letter-spacing: 0.012vmin;\n    margin: 0 0 0.64rem;\n    position: relative;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background: none;\n    transform: translateX(0);\n  }\n}\nheader nav .menu ul li a:after {\n  content: \"\";\n  width: 0;\n  height: 100%;\n  background: #89712f;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n  transition: width 320ms cubic-bezier(0.65, 0, 0.35, 1);\n  z-index: -1;\n}\n@media screen and (max-width: 1023px) {\n  header nav .menu ul li a:after {\n    display: none;\n  }\n}\nheader nav .menu ul li a:hover:after {\n  width: 100%;\n  left: 0;\n  right: auto;\n}\nheader nav .menu ul li a svg {\n  width: 3.4vmin;\n  height: 3.4vmin;\n  display: inline-block;\n  margin: 0 0 0 0.8vmin;\n  transform: translateY(0.33vmin);\n}\n@media screen and (max-width: 769px) {\n  header nav .menu ul li a svg {\n    width: 5vmin;\n    height: 5vmin;\n    transform: translateY(25%);\n  }\n}\nheader nav .meta {\n  width: 100%;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  color: #fafbf6;\n  fill: #fafbf6;\n  padding: 1.6rem calc(var(--size) + 2vw);\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-column-gap: 2rem;\n}\n@media screen and (max-width: 769px) {\n  header nav .meta {\n    width: 100vw;\n    position: relative;\n    top: 0;\n    left: 0;\n    right: auto;\n    bottom: auto;\n    align-self: flex-end;\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\nheader nav .meta > * {\n  align-self: center;\n}\n@media screen and (max-width: 769px) {\n  header nav .meta > * {\n    justify-self: center;\n  }\n}\nheader nav .meta dt {\n  font-size: 0.92rem;\n  line-height: 1.6;\n  text-align: justify;\n}\n@media screen and (max-width: 769px) {\n  header nav .meta dt {\n    font-size: 0.96rem;\n    text-align: center;\n  }\n}\nheader nav .meta dd {\n  font-size: 1.24rem;\n  line-height: 1.4;\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 0.64rem;\n}\n@media screen and (max-width: 769px) {\n  header nav .meta dd {\n    font-size: 1.32rem;\n    display: block;\n    line-height: 1.8;\n  }\n}\nheader nav .meta dd svg {\n  width: 2.32rem;\n  height: 2.32rem;\n}","@import url('https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz@0,6..96;1,6..96&display=swap');\n\n/* BASE COLOR\n------------------------------------------------------------*/\n$normal: #24271c;\n$link: $normal;\n\n$white: #fafbf6;\n$black: #191b13;\n$gray: #f1f2ed;\n$border:#e8e8eb;\n\n$base: #475e08;\n$light: #5b7612;\n$sub : #89712f;\n$ease: cubic-bezier(0.65, 0, 0.35, 1);\n\n\n/* DISPLAY SETTING\n------------------------------------------------------------*/\n$width: 1024px;\n$tab: $width - 1px;\n$phone: 769px;\n\n\n/* OTHER SETTING\n------------------------------------------------------------*/\n:root{\n\tfont-size: calc(14.5px + (16 - 14.5) * ((100vw - 1440px) / (1920 - 1440)));\n\t--cx: 0;\n\t--cy: 0;\n\t--vw: 100vw;\n\t--vh: 100vh;\n  --screen: 0px;\n  --size: 32px;\n\t@media screen and (min-width: 1920px){\n\t\tfont-size: 16px;\n\t}\n\t@media screen and (max-width: $tab){\n\t\tfont-size: 14px;\n    --size: 16px;\n\t}\n\t@media screen and (max-width: $phone){\n\t\tfont-size: 13.5px;\n    --size: 10px;\n\t}\n}\n\n@mixin flex($parent:wrap , $child:space-between){\n\tdisplay: flex;\n\tflex-flow: row $parent;\n\tjustify-content: $child;\n  flex-wrap: nowrap;\n}\n\n@function side(){\n  @return calc(var(--size) + 2vw);\n}\n\n@function side2x(){\n  @return calc(#{side()} * 1.66);\n}\n\n@mixin btn($color: $white, $bg: $normal, $sub: $light, $padding: .8rem 3.2rem){\n  color: $color;\n  font-size: 1.08rem;\n  line-height: 1.5;\n  padding: $padding;\n  border-radius: 999rem;\n  overflow: hidden;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  transition: color 320ms $ease;\n  &:before,\n  &:after{\n    content: '';\n    background: $bg;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: -1;\n    transition: width 320ms $ease;\n  }\n  &::before{\n    background: $sub;\n  }\n  svg{\n    width: 1.2rem;\n    fill: $color;\n    display: inline-block;\n    margin: 0 0 0 .64rem;\n    transition: fill 320ms $ease;\n  }\n  &:hover{\n    color: $color;\n    &:after{\n      left: auto;\n      right: 0;\n      width: 0;\n    }\n    svg{\n      fill: $color;\n    }\n  }\n}\n\n@mixin texture($light: 0){\n  @if $light == 0 {\n    background: $base url(/images/common/texture.webp) repeat left top / 250px;\n  }\n  @if $light == -1 {\n    background: $normal url(/images/common/texture_b.webp) repeat left top / 250px;\n  }\n  @if $light == -2 {\n    background: $black url(/images/common/texture_d.webp) repeat left top / 250px;\n  }\n}\n\n@font-face {\n\tfont-family: \"Yu Gothic\";\n\tsrc: local(\"Yu Gothic Medium\");\n\tfont-weight: 100;\n}\n@font-face {\n\tfont-family: \"Yu Gothic\";\n\tsrc: local(\"Yu Gothic Medium\");\n\tfont-weight: 200;\n}\n@font-face {\n\tfont-family: \"Yu Gothic\";\n\tsrc: local(\"Yu Gothic Medium\");\n\tfont-weight: 300;\n}\n@font-face {\n\tfont-family: \"Yu Gothic\";\n\tsrc: local(\"Yu Gothic Medium\");\n\tfont-weight: 400;\n}\n@font-face {\n\tfont-family: \"Yu Gothic\";\n\tsrc: local(\"Yu Gothic Medium\");\n\tfont-weight: 500;\n}\n@font-face {\n\tfont-family: \"Yu Gothic\";\n\tsrc: local(\"Yu Gothic Bold\");\n\tfont-weight: bold;\n}\n\n@mixin font(){\n\tfont-family: 'Yu Gothic', '游ゴシック' ,YuGothic, 'Hiragino Kaku Gothic Pro', 'メイリオ', Meiryo, 'MS Pゴシック', Helvetica, Arial, Verdana, sans-serif;\n\tfont-weight:500;\n  font-size: 1rem;\n\t-webkit-font-feature-settings : \"palt\";\n\tfont-feature-settings : \"palt\";\n\tletter-spacing: 0.024em;\n}\n@mixin min(){\n\tfont-family: '游明朝', YuMincho, 'ヒラギノ明朝 ProN W3', 'Hiragino Mincho ProN', 'HG明朝E', 'ＭＳ Ｐ明朝', 'ＭＳ 明朝', serif;\n\tfont-weight: 500;\n  font-size: 1rem;\n\t-webkit-font-feature-settings : \"palt\";\n\tfont-feature-settings : \"palt\";\n\tletter-spacing: 0.024em;\n}\n\n@mixin default($color:#000, $link:#D00, $bg:#FFF){\n\t*{\n\t\tmargin:0;\n\t\tpadding:0;\n\t}\n\t*, *:before, *:after {\n\t\t-webkit-box-sizing: border-box;\n\t\t-moz-box-sizing: border-box;\n\t\t-o-box-sizing: border-box;\n\t\t-ms-box-sizing: border-box;\n\t\tbox-sizing: border-box;\n\t}\n\thtml{\n\t\t-webkit-text-size-adjust: none;\n\t}\n\tbody{\n\t\tcolor: $color;\n    fill: $color;\n\t\t@include texture(-2);\n\t\tline-height: 1.8;\n\t\t@include min();\n    position: relative;\n    &:before{\n      content: '';\n      width: 100%;\n      height: 75dvh;\n      position: absolute;\n      left: 0;\n      bottom: 0;\n      background: linear-gradient(0deg, #000, rgba($black,0));\n      opacity: .48;\n    }\n\t}\n\th1,h2,h3,h4,h5,h6{\n\t\tfont-weight: 700;\n\t}\n\timg {\n\t\t-ms-interpolation-mode: bicubic;\n\t\tvertical-align: bottom;\n\t\timage-rendering: -webkit-optimize-contrast;\n\t}\n\ti,strong{\n\t\tfont-style: normal;\n\t}\n\ta{\n\t\ttext-decoration: none;\n\t\toutline: none;\n\t\tcursor: pointer;\n\t\tcolor: $link;\n\t}\n  ul,ol{\n    list-style: none;\n  }\t\n  input[type=\"text\"],\n  input[type=\"tel\"],\n  input[type=\"email\"],\n  input[type=\"password\"],\n  input[type=\"submit\"],\n  input[type=\"button\"],\n  select,\n  textarea{\n    outline: none;\n    @media screen and (max-width: $tab){\n      -webkit-appearance: none;\n    }\n  }\n}","@use \"@/src/scss/module/_module.scss\" as module;\n\n$spSize: 4.8rem;\n.nav-enter-active,\n.nav-leave-active {\n  transition: opacity 0.5s module.$ease;\n}\n.nav-enter-from,\n.nav-leave-to {\n  opacity: 0;\n}\nheader{\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: auto auto;\n  z-index: 1000;\n  @media screen and (max-width: module.$phone){\n    position: absolute;\n  }\n  &.pc{\n    &:before{\n      height: 25dvh;\n      opacity: .8;\n    }\n  }\n  &:before{\n    content: '';\n    width: 100%;\n    height: 15dvh;\n    position: absolute;\n    top: 0;\n    left: 0;\n    background: linear-gradient(to top, rgba(#000,.0), rgba(#000,1));\n    opacity: .4;\n    pointer-events: none;\n    z-index: -1;\n  }\n  .logo{\n    margin: 1.2rem 0 0 module.side();\n    width: 14.4rem;\n    justify-self: flex-start;\n    @media screen and (max-width: module.$phone){\n      width: 10rem;\n    }\n    img{\n      width: 100%;\n    }\n  }\n  .gnavi{\n    position: absolute;\n    top: 1.6rem;\n    left: 50%;\n    transform: translate(-50%, 0);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    @media screen and (max-width: module.$tab){\n      top: 0;\n      min-height: 100vmax;\n    }\n    li{\n      margin: 0 0 0 2.4rem;\n      @media screen and (max-width: module.$tab){\n        margin: 0;\n      }\n      &:first-child{\n        margin: 0;\n      }\n      a{\n        font-size: 1.08rem;\n        color: module.$white;\n        position: relative;\n        transition: color 200ms module.$ease;\n        &:before{\n          content: '';\n          width: 0;\n          height: 1px;\n          background: module.$sub;\n          position: absolute;\n          left: 50%;\n          bottom: 0;\n          transform: translateX(-50%);\n          transition: width 200ms module.$ease;\n          @media screen and (max-width: module.$tab){\n            height: auto;\n            left: 0;\n            bottom: auto;\n            top: 0;\n            position: relative;\n          }\n        }\n        &:after{\n          content: attr(data-eng);\n          font-size: .88rem;\n          display: block;\n          text-align: center;\n        }\n        svg{\n          width: 1.1rem;\n          height: 1.1rem;\n          fill: module.$white;\n          display: inline-block;\n          margin: 0 0 0 .32rem;\n          transition: fill 200ms module.$ease;\n        }\n        &:hover{\n          color: module.$sub;\n          @media screen and (max-width: module.$tab){\n            color: module.$white;\n          }\n          svg{\n            fill: module.$sub;\n            @media screen and (max-width: module.$tab){\n              fill: module.$white;\n            }\n          }\n          &:before{\n            width: 100%;\n          }\n        }\n      }\n    }\n  }\n  .other{\n    position: fixed;\n    top: 0;\n    right: calc(6.4rem - 1px);\n    height: 6.4rem;\n    background: darken(module.$base, 4%);\n    color: module.$gray;\n    line-height: 1.5;\n    @include module.flex();\n    align-items: center;\n    justify-content: center;\n    padding: 0 2rem;\n    z-index: 900;\n    border-radius: 0 0 0 1rem;\n    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n    transition: clip-path 800ms module.$ease, background 400ms module.$ease;\n    &.pc{\n      right: 0;\n    }\n    @media screen and (max-width: module.$phone){\n      right: calc(#{$spSize} - 1px);\n      height: $spSize;\n      padding: 0 1.6rem;\n    }\n    &.active{\n      clip-path: polygon(100% 0, 100% 0, 100% 100%, 100% 0);\n    }\n    &:hover{\n      background: module.$sub;\n    }\n    div{\n      font-size: .72rem;\n      text-align: center;\n      @media screen and (max-width: module.$phone){\n        font-size: .72rem;\n        padding: .32rem 0;\n      }\n      svg{\n        width: 2.4rem;\n        fill: module.$gray;\n        display: block;\n        margin: 0 auto .32rem;\n        @media screen and (max-width: module.$phone){\n          width: 1.4rem;\n          margin-bottom: .4rem;\n        }\n      }\n    }\n  }\n  .lang{\n    position: absolute;\n    top: 1rem;\n    right: calc(16rem);\n    overflow: hidden;\n    display: grid;\n    grid-template-columns: auto 1fr;\n    border-radius: 999rem;\n    background: module.$white;\n    @media screen and (max-width: module.$phone){\n      right: module.side();\n      top: 6rem;\n    }\n    &.pc{\n      top: 2rem;\n      right: calc(10rem);\n    }\n    > svg{\n      fill: module.$normal;\n      position: absolute;\n      right: .64rem;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 1.2rem;\n    }\n    span{\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: module.$white;\n      padding: 0 .4rem;\n      svg{\n        width: 1.6rem;\n        fill: module.$base;\n      }\n    }\n    select{\n      @include module.font();\n      font-size: 1.04rem;\n      line-height: 1.5;\n      padding: .4rem 0;\n      padding-right: 2rem;\n      border: none;\n      color: module.$normal;\n      background: transparent;\n      -webkit-appearance: none;\n      appearance: none;\n      cursor: pointer;\n    }\n  }\n  .trg{\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 6.4rem;\n    height: 6.4rem;\n    cursor: pointer;\n    overflow: hidden;\n    z-index: 1000;\n    @media screen and (max-width: module.$phone){\n      width: $spSize;\n      height: $spSize;\n    }\n    &:before,\n    &:after{\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background: module.$base;\n      z-index: -1;\n    }\n    &:after{\n      width: 0;\n      left: auto;\n      right: 0;\n      background: module.$black;\n      transition: all 320ms module.$ease;\n    }\n    &:hover{\n      &:after{\n        width: 100%;\n        left: 0;\n        right: auto;\n      }\n    }\n    &.active{\n      &:after{\n        width: 100%;\n      }\n      &:hover{\n        &:after{\n          background: module.$normal;\n        }\n      }\n      i{\n        width: 0;\n        &:first-of-type,\n        &:last-of-type{\n          width: 40%;\n          top: 50%;\n        }\n        &:first-of-type{\n          transform: translate(-50%) rotate(45deg);\n        }\n        &:last-of-type{\n          transform: translate(-50%) rotate(-45deg);\n        }\n      }\n    }\n    i{\n      width: 33%;\n      height: 1px;\n      background: module.$white;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%);\n      transition: all 320ms module.$ease;\n      &:first-of-type{\n        top: calc(50% - .5rem);\n      }\n      &:last-of-type{\n        top: calc(50% + .5rem);\n      }\n    }\n  }\n  .fix{\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: module.$base;\n    @media screen and (max-width: module.$tab){\n      overflow: auto;\n    }\n  }\n  nav{\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 9;\n    @include module.texture();\n    @include module.flex();\n    align-items: center;\n    justify-content: center;\n    @media screen and (max-width: module.$phone){\n      overflow: auto;\n      display: grid;\n      grid-template-columns: 1fr;\n      > *{\n        align-self: flex-start;\n      }\n    }\n    .logo{\n      position: absolute;\n      top: 0;\n      left: 0;\n      z-index: 10;\n    }\n    .pics{\n      width: 50%;\n      height: 100%;\n      position: absolute;\n      top: 0;\n      right: 0;\n      display: grid;\n      @media screen and (max-width: module.$tab){\n        width: 100%;\n        height: 30%;\n        grid-template-rows: 1fr;\n      }\n      @media screen and (max-width: module.$phone){\n        height: 25%;\n      }\n      figure{\n        position: relative;\n        overflow: hidden;\n        &:before{\n          content: '';\n          position: absolute;\n          width: 100%;\n          height: 100%;\n          top: 0;\n          right: 0;\n          @include module.texture();\n          z-index: 2;\n          @media screen and (max-width: module.$phone){\n            display: none;\n          }\n        }\n        &:nth-of-type(odd){\n          &:before{\n            left: 0;\n            right: auto;\n          }\n        }\n        img{\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n          display: block;\n          position: relative;\n        }\n      }\n      &.active{\n        figure{\n          &:before{\n            animation: menuPicBefore 800ms 200ms module.$ease forwards;\n          }\n          img{\n            animation: menuPic 1200ms module.$ease forwards;\n          }\n          @keyframes menuPicBefore {\n            0%{\n              width: 100%;\n            }\n            100%{\n              width: 0;\n            }\n          }\n          @keyframes menuPic {\n            0%{\n              transform: scale(1.1);\n            }\n            100%{\n              transform: scale(1);\n            }\n          }\n        }\n      }\n    }\n    .menu{\n      width: 50%;\n      height: 100%;\n      padding: 0 0 5.6rem;\n      position: absolute;\n      background: url(/images/common/menu_circle.webp) no-repeat left top / 80%;\n      left: 0;\n      top: 0;\n      @include module.flex();\n      align-items: center;\n      justify-content: center;\n      @media screen and (max-width: module.$tab){\n        width: 100%;\n        height: 70%;\n        top: auto;\n        bottom: 0;\n      }\n      @media screen and (max-width: module.$phone){\n        display: grid;\n        grid-template-rows: 2fr;\n        order: 2;\n        height: 75%;\n        align-self: center;\n      }\n      ul{\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        grid-column-gap: 2.4rem;\n        grid-row-gap: 2.4rem;\n        margin: 4rem 0 0;\n        @media screen and (max-width: module.$tab){\n          grid-column-gap: module.side();\n          grid-row-gap: 2rem;\n          margin: 0;\n        }\n        @media screen and (max-width: module.$phone){\n          grid-template-columns: repeat(2, 1fr);\n          padding: 3.2rem module.side() 1.6rem;\n          text-align: center;\n        }\n        &.active{\n          li{\n            animation: showMenuList 600ms ease-in-out forwards;\n            @for $i from 1 through 10{\n              &:nth-child(#{$i}){\n                animation-delay: $i * 40ms + 400ms;\n              }\n            }\n            @keyframes showMenuList {\n              0%{\n                transform: translateY(2.4rem);\n                opacity: 0;\n              }\n              100%{\n                transform: translateY(0);\n                opacity: 1;\n              }\n            }\n          }\n        }\n        li{\n          line-height: 1;\n          opacity: 0;\n          a{\n            font-size: 3.72vmin;\n            letter-spacing: .12rem;\n            line-height: 1;\n            color: module.$white;\n            fill: module.$white;\n            display: inline-block;\n            position: relative;\n            padding: .4rem;\n            z-index: 1;\n            @media screen and (max-width: module.$phone){\n              font-size: 4.2vmin;\n            }\n            &:before{\n              content: attr(data-eng);\n              display: block;\n              font-size: 1.6vmin;\n              margin: 0 0 .8rem .24rem;\n              letter-spacing: .08;\n              white-space: nowrap;\n              @media screen and (max-width: module.$phone){\n                font-size: 3.2vmin;\n                letter-spacing: .012vmin;\n                margin: 0 0 .64rem;\n                position: relative;\n                top: 0;\n                left: 0;\n                width: 100%;\n                background: none;\n                transform: translateX(0);\n              }\n            }\n            &:after{\n              content: '';\n              width: 0;\n              height: 100%;\n              background: module.$sub;\n              position: absolute;\n              top: 50%;\n              right: 0;\n              transform: translateY(-50%);\n              transition: width 320ms module.$ease;\n              z-index: -1;\n              @media screen and (max-width: module.$tab){\n                display: none;\n              }\n            }\n            &:hover{\n              &:after{\n                width: 100%;\n                left: 0;\n                right: auto;\n              }\n            }\n            svg{\n              width: 3.4vmin;\n              height: 3.4vmin;\n              display: inline-block;\n              margin: 0 0 0 .8vmin;\n              transform: translateY(.33vmin);\n              @media screen and (max-width: module.$phone){\n                width: 5vmin;\n                height: 5vmin;\n                transform: translateY(25%);\n              }\n            }\n          }\n        }\n      }\n    }\n    .meta{\n      width: 100%;\n      position: absolute;\n      right: 0;\n      bottom: 0;\n      color: module.$white;\n      fill: module.$white;\n      padding: 1.6rem module.side();\n      display: grid;\n      grid-template-columns: auto 1fr;\n      grid-column-gap: 2rem;\n      @media screen and (max-width: module.$phone){\n        width: 100vw;\n        position: relative;\n        top: 0;\n        left: 0;\n        right: auto;\n        bottom: auto;\n        align-self: flex-end;\n        grid-template-columns: 1fr;\n        gap: 1rem;\n      }\n      > *{\n        align-self: center;\n        @media screen and (max-width: module.$phone){\n          justify-self: center;\n        }\n      }\n      dt{\n        font-size: .92rem;\n        line-height: 1.6;\n        text-align: justify;\n        @media screen and (max-width: module.$phone){\n          font-size: .96rem;\n          text-align: center;\n        }\n      }\n      dd{\n        font-size: 1.24rem;\n        line-height: 1.4;\n        @include module.flex();\n        justify-content: flex-start;\n        align-items: center;\n        gap: .64rem;\n        @media screen and (max-width: module.$phone){\n          font-size: 1.32rem;\n          display: block;\n          line-height: 1.8;\n        }\n        svg{\n          width: 2.32rem;\n          height: 2.32rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
